import { css } from '@emotion/css';

export const dateStampStyles = css`
  transform: scale(0.8);
  border-radius: 1.2rem;
`;
